import { render, staticRenderFns } from "./AssetInfoDrawer.vue?vue&type=template&id=1b279a60"
import script from "./AssetInfoDrawer.vue?vue&type=script&lang=js"
export * from "./AssetInfoDrawer.vue?vue&type=script&lang=js"
import style0 from "./AssetInfoDrawer.vue?vue&type=style&index=0&id=1b279a60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports